import {STARGATE_BASE_PATH} from 'constants/urls'
import resolveUrl from 'utils/resolveUrl'

const ENV_API_BASE = STARGATE_BASE_PATH || process.env.REACT_APP_REQREPO_HOST

export const apiBase = ENV_API_BASE || '/api-gw'
export const credentialSettings = ENV_API_BASE ? 'include' : 'same-origin'
export const portalBase = process.env.REACT_APP_PORTAL_HOST || ''

interface RequestOptions {
  [key: string]: unknown
  headers?: {
    [key: string]: unknown
  }
}

export class ApiClient {
  private readonly _apiBase: string

  public constructor(apiBase = '') {
    this._apiBase = apiBase
  }

  public fetch(
    url: string,
    options: RequestOptions = {},
    _includeAuth = true,
    hasDefaultHeaders = true,
  ): Promise<Response> {
    const defaultHeaders: {[key: string]: string} = {}
    if (hasDefaultHeaders) {
      defaultHeaders['Accept'] = 'application/json'
      defaultHeaders['Content-type'] = 'application/json'
    }

    const requestOptions: Record<string, unknown> = {
      ...options,
      credentials: credentialSettings,
      headers: {
        ...defaultHeaders,
        ...(options.headers ? options.headers : {}),
      },
    }
    return fetch(resolveUrl(url, this._apiBase), requestOptions)
  }
}

export const apiClient = new ApiClient(apiBase)
export const portalApiClient = new ApiClient(portalBase)
export {stargate, legacyStargate} from './stargate'

export default apiClient
